import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { LogoComponent } from '@shared/logo/logo.component';
import { Navigation, navigation } from '@shared/navigation/navigation.enum';
import { GetStartedComponent } from '@shared/get-started/get-started.component';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { SocialMediaComponent } from '@shared/social-media/social-media.component';
import { RouterLink } from '@angular/router';
import { AppPath } from '@shared/routes/app-routing.const';

@Component({
    selector: 'companyid-footer',
    imports: [LogoComponent, GetStartedComponent, ContentWrapperComponent, SocialMediaComponent, RouterLink],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    public readonly footerNavigations: Navigation[] = navigation;
    public readonly privacyPolicyPath = AppPath.PRIVACY_POLICY;
    public readonly version = RELEASE_VERSION;
    public readonly copyrightText = `2016-${new Date().getFullYear()}, ${$localize`All Rights Reserved`}. ${this.version}`;
}
